<script setup>
import { navigation } from '@/constants/navigation';
import { documents } from '@/constants/documents';
import { useGlobalStore } from '@/stores/global';

const globalStore = useGlobalStore();

const currentYear = computed(() => new Date().getFullYear());

function closeMobileMenu() {
  globalStore.closeMobileMenu();
}
</script>

<template>
  <div class="layout-mobile-menu">
    <div class="layout-mobile-menu__container container">
      <div class="layout-mobile-menu__body">
        <nav class="layout-mobile-menu__navigation">
          <ul class="layout-mobile-menu__navigation-list">
            <li
              v-for="(navigationItem, index) in navigation"
              :key="index"
              class="layout-mobile-menu__navigation-item"
            >
              <NuxtLink
                class="layout-mobile-menu__navigation-link"
                :to="{ hash: `#${navigationItem.id}` }"
              >
                <span
                  class="layout-mobile-menu__font layout-mobile-menu__font--navigation"
                >
                  {{ navigationItem.label }}
                </span>
              </NuxtLink>
            </li>
          </ul>
        </nav>

        <div class="layout-mobile-menu__footer">
          <div class="layout-mobile-menu__copyright">
            <span
              class="layout-mobile-menu__font layout-mobile-menu__font--copyright"
            >
              © {{ currentYear }} Centour.io, All Rights Reserved
            </span>
          </div>

          <ul class="layout-mobile-menu__documents">
            <li class="layout-mobile-menu__document-item">
              <a
                class="layout-mobile-menu__document-link"
                :href="documents.termsOfService.src"
                target="_blank"
              >
                <span
                  class="layout-mobile-menu__font layout-mobile-menu__font--document"
                >
                  {{ documents.termsOfService.label }}
                </span>
              </a>
            </li>

            <li class="layout-mobile-menu__document-item">
              <a
                class="layout-mobile-menu__document-link"
                :href="documents.privacyPolicy.src"
                target="_blank"
              >
                <span
                  class="layout-mobile-menu__font layout-mobile-menu__font--document"
                >
                  {{ documents.privacyPolicy.label }}
                </span>
              </a>
            </li>

            <li class="layout-mobile-menu__document-item">
              <a
                class="layout-mobile-menu__document-link"
                :href="documents.cookiePolicy.src"
                target="_blank"
              >
                <span
                  class="layout-mobile-menu__font layout-mobile-menu__font--document"
                >
                  {{ documents.cookiePolicy.label }}
                </span>
              </a>
            </li>
          </ul>

          <UiButtonCircle
            class="layout-mobile-menu__button layout-mobile-menu__button--scroll-top"
            @click="closeMobileMenu"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.layout-mobile-menu {
  width: 100%;

  &__font {
    &--navigation {
      font-size: em(14);
      font-weight: 700;
      line-height: 100%;

      @include media-breakpoint-down(sm) {
        font-size: em(12);
      }
    }

    &--copyright {
      font-family: $font-family-second;
      font-size: em(10);
      font-weight: 500;
      line-height: 100%;
    }

    &--document {
      font-family: $font-family-second;
      font-size: em(10);
      font-weight: 500;
      line-height: 100%;
    }
  }

  &__container {
    max-width: em(768);
    padding: em(10);

    @include media-breakpoint-down(sm) {
      padding: 0;
    }
  }

  &__body {
    padding: em(40) em(40) em(27);
    background: #c9d0d9e5;
    backdrop-filter: blur(4px);
    border-radius: em(24);
  }

  &__navigation {
    margin-bottom: em(57);

    @include media-breakpoint-down(sm) {
      margin-bottom: em(58);
    }
  }

  &__navigation-list {
  }

  &__navigation-item {
    &:not(:last-child) {
      margin-bottom: em(11);
    }
  }

  &__navigation-link {
    display: block;
    padding: em(10) em(20);
    color: $text-dark-main;
    text-transform: uppercase;
    background-color: rgba($color-white, 0.1);
    backdrop-filter: blur(4px);
    border-radius: em(5);
    transition: background-color $time-fast ease-out;

    @include hover-active-focus {
      background-color: $color-white;
    }
  }

  &__footer {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: fit-content;
    padding: 0 em(46);
    margin: 0 auto;

    @include media-breakpoint-down(sm) {
      padding: 0 em(0);
    }
  }

  &__copyright {
    margin-bottom: em(3);
    color: $text-dark-on-red;
    text-transform: uppercase;
  }

  &__documents {
    display: flex;
  }

  &__document-item {
    &:not(:last-child) {
      margin-right: em(13);
    }
  }

  &__document-link {
    color: $text-dark-on-red;
    text-transform: uppercase;
    transition: color $time-fast ease-out;

    @include hover-active-focus {
      color: $accent-red;
    }
  }

  &__button {
    &--scroll-top {
      position: absolute;
      top: em(2);
      right: 0;

      @include media-breakpoint-down(sm) {
        right: em(-46);
      }
    }
  }
}
</style>
